import { MdEmergencyRecording } from 'react-icons/md'
import React, { forwardRef } from 'react'
import { ButtonWithIcon }  from './ButtonWithIcon'

export const VideoButton = forwardRef((props, ref) => {
  return <ButtonWithIcon icon={MdEmergencyRecording} {...props} ref={ref} />
})
